import { isNull } from 'lodash';
import { DateTime } from 'luxon';
import { createContext, useContext, useMemo } from 'react';
import { IChildrenProps } from 'types/ChildrenProps';
import ITimeRange from 'types/TimeRange';
import useMemberTimeEntryDataReportData, {
  IMemberTimeEntryReportDataFilter,
} from '../hooks/useMemberTimeEntryDataReportData';

export interface IMemberTimeEntryDataReportContextState extends ReturnType<typeof useMemberTimeEntryDataReportData> {
  timeRange: ITimeRange<DateTime>;
}

export const MemberTimeEntryDataReportContext = createContext<IMemberTimeEntryDataReportContextState | null>(null);

export function useMemberTimeEntryDataReportState() {
  const context = useContext(MemberTimeEntryDataReportContext);

  if (isNull(context)) {
    throw Error(
      '`useMemberTimeEntryDataReportState` must be nested within a `MemberTimeEntryDataReportContextProvider.`'
    );
  }

  return context!;
}

interface IMemberTimeEntryDataReportContextProviderProps extends IChildrenProps {
  scroller: HTMLElement | Document | null;
  filter: IMemberTimeEntryReportDataFilter;
}

export function MemberTimeEntryDataReportContextProvider({
  children,
  filter,
  scroller,
}: IMemberTimeEntryDataReportContextProviderProps) {
  const result = useMemberTimeEntryDataReportData(scroller, filter);
  const value = useMemo(
    () => ({
      ...result,
      timeRange: filter.timeRange,
    }),
    [result, filter.timeRange]
  );

  return (
    <MemberTimeEntryDataReportContext.Provider value={value}>{children}</MemberTimeEntryDataReportContext.Provider>
  );
}
